// extracted by mini-css-extract-plugin
export default {"loading":"ProductAddedModal_loading__Q-6vI"};